module.exports = __webpack_public_path__ + "img/graphic-5.6e224f81.png";